function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isElementOfType } from '@deephaven/react-hooks';
import { useCallback } from 'react';
import ActionGroup from "../ActionGroup.js";
import ActionMenu from "../ActionMenu.js";
import { ItemContent } from "../ItemContent.js";
import { ListActionGroup } from "../ListActionGroup.js";
import { ListActionMenu } from "../ListActionMenu.js";
import { Item } from "../shared.js";
import { getItemKey, ITEM_EMPTY_STRING_TEXT_VALUE } from "./itemUtils.js";
import { wrapIcon, wrapPrimitiveWithText } from "./itemWrapperUtils.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Returns a render function that can be used to render a normalized item in
 * collection components.
 * @param itemIconSlot Slot to use for item icons
 * @param showItemDescriptions Whether to show item descriptions
 * @param showItemIcons Whether to show item icons
 * @param tooltipOptions Tooltip options to use when rendering the item
 * @param actions Optional actions to render with the item
 * @returns Render function for normalized items
 */
export function useRenderNormalizedItem(_ref) {
  var itemIconSlot = _ref.itemIconSlot,
    showItemDescriptions = _ref.showItemDescriptions,
    showItemIcons = _ref.showItemIcons,
    tooltipOptions = _ref.tooltipOptions,
    actions = _ref.actions;
  return useCallback(normalizedItem => {
    var _normalizedItem$item, _normalizedItem$item$, _normalizedItem$item2, _normalizedItem$item3, _normalizedItem$item4;
    var itemKey = getItemKey(normalizedItem);
    var content = wrapPrimitiveWithText((_normalizedItem$item = normalizedItem.item) === null || _normalizedItem$item === void 0 ? void 0 : _normalizedItem$item.content);
    var textValue = (_normalizedItem$item$ = (_normalizedItem$item2 = normalizedItem.item) === null || _normalizedItem$item2 === void 0 ? void 0 : _normalizedItem$item2.textValue) !== null && _normalizedItem$item$ !== void 0 ? _normalizedItem$item$ : itemKey == null ? undefined : String(itemKey);
    var description = showItemDescriptions ? wrapPrimitiveWithText((_normalizedItem$item3 = normalizedItem.item) === null || _normalizedItem$item3 === void 0 ? void 0 : _normalizedItem$item3.description, 'description') : null;
    var icon = showItemIcons ? wrapIcon((_normalizedItem$item4 = normalizedItem.item) === null || _normalizedItem$item4 === void 0 ? void 0 : _normalizedItem$item4.icon, itemIconSlot) : null;
    var action = null;
    if (isElementOfType(actions, ListActionGroup)) {
      action = /*#__PURE__*/_jsx(ActionGroup
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread(_objectSpread({}, actions.props), {}, {
        onAction: key => actions.props.onAction(key, itemKey),
        onChange: keys => {
          var _actions$props$onChan, _actions$props;
          return (_actions$props$onChan = (_actions$props = actions.props).onChange) === null || _actions$props$onChan === void 0 ? void 0 : _actions$props$onChan.call(_actions$props, keys, itemKey);
        }
      }));
    } else if (isElementOfType(actions, ListActionMenu)) {
      action = /*#__PURE__*/_jsx(ActionMenu
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread(_objectSpread({}, actions.props), {}, {
        onAction: key => actions.props.onAction(key, itemKey),
        onOpenChange: isOpen => {
          var _actions$props$onOpen, _actions$props2;
          return (_actions$props$onOpen = (_actions$props2 = actions.props).onOpenChange) === null || _actions$props$onOpen === void 0 ? void 0 : _actions$props$onOpen.call(_actions$props2, isOpen, itemKey);
        }
      }));
    }
    return /*#__PURE__*/_jsx(Item
    // Note that setting the `key` prop explicitly on `Item` elements
    // causes the picker to expect `selectedKey` and `defaultSelectedKey`
    // to be strings. It also passes the stringified value of the key to
    // `onSelectionChange` handlers` regardless of the actual type of the
    // key. We can't really get around setting in order to support Windowed
    // data, so we'll need to do some manual conversion of keys to strings
    // in other components that use this hook.
    , {
      // The `textValue` prop gets used to provide the content of `<option>`
      // elements that back the Spectrum Picker. These are not visible in the UI,
      // but are used for accessibility purposes, so we set to an arbitrary
      // `ITEM_EMPTY_STRING_TEXT_VALUE` value so that they are not empty strings.
      textValue: textValue === '' ? ITEM_EMPTY_STRING_TEXT_VALUE : textValue,
      children: /*#__PURE__*/_jsxs(ItemContent, {
        tooltipOptions: tooltipOptions,
        children: [icon, content, description, action]
      })
    }, itemKey);
  }, [actions, itemIconSlot, showItemDescriptions, showItemIcons, tooltipOptions]);
}
export default useRenderNormalizedItem;
//# sourceMappingURL=useRenderNormalizedItem.js.map